









































import EditOnClickField from '@/components/util/EditOnClickField.vue';
import BuildingDisplayComponent from '@/components/system/BuildingDisplayComponent.vue';

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { PropertiesApi, Property, WorkordersApi } from 'performo-api';

@Component({
  components: { EditOnClickField, BuildingDisplayComponent },
  computed: mapGetters({
    ordersApi: 'ordersApi',
    propertiesApi: 'propertiesApi'
  })
})
export default class BuildingEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, type: Boolean, default: false })
  private canEdit!: boolean;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, type: String, default: 'Building' })
  private label!: string;

  @Prop({ required: true, default: '' })
  private value!: string | number | undefined;

  private buildingMode = 'read';

  private updatedValue: string | number | undefined = undefined;
  private loading!: boolean;

  private property: Property = {};

  private propertiesApi!: PropertiesApi;
  private ordersApi!: WorkordersApi;

  data() {
    return { updatedValue: this.value, loading: false };
  }

  private get location1Label() {
    return this.property?.location1Label;
  }

  @Watch('propertyId', { immediate: true })
  private async propertyIdChanged() {
    this.property = await this.propertiesApi.getProperty({
      propertyId: this.propertyId
    });
  }

  private async handleBuildingChange(building: string) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === building) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeLocation({
        workorderId: this.workorderId,
        changeOrderLocationCommand: {
          newLocation1: building,
          newFloor: '',
          newLocation2: ''
        }
      });
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    // finally exit
    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.buildingMode = 'read';
    this.loading = false;
  }
}
